$(function(){

  $(".txtfadein").children().addBack().contents().each(function(){
    if (this.nodeType == 3) {
      var $this = $(this);
      $this.replaceWith($this.text().replace(/(\S)/g, "<span>$&</span>"));
    }
  });

  var delaySpeed = 1200; // 1秒ずつ遅らせる
  var fadeSpeed = 2000; // 1秒かける

  $(window).on('load', function() {

    $('.txtfadein').each(function(i){
      $(this).delay(i*(delaySpeed)).animate({
        'opacity' : '1'
      },fadeSpeed);
    });

  });

});
